/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import IncentiveDetailCategorized from '../components/IncentiveDetailCategorized';
import {
	FOOTNOTE_INDICATOR,
	ONLY_AT,
	MANUFACTURER,
	CONDITIONAL,
	CONDITIONAL_SPECIAL,
	CONDITIONAL_SPECIAL_DESCRIPTION,
	DEALERSHIP
} from '../constants/constants';

class IncentivesCategorized extends React.Component {
	render() {
		const {
			categorizedIncentives,
			separateConditional,
			setModalStateData,
			isMobile,
			accountName
		} = this.props;

		if (separateConditional) {
			return (
				<Common
					render={({ labels }) => {
						const dealerHeading = accountName
							? `${labels.get(ONLY_AT)} ${accountName}`
							: `${labels.get(DEALERSHIP)}`;
						const dealerHeadingConditional = accountName
							? `${labels.get(ONLY_AT)} ${accountName}
								(${labels.get(CONDITIONAL)})`
							: `${labels.get(DEALERSHIP)}
								(${labels.get(CONDITIONAL)})`;
						return (
							<React.Fragment>
								<IncentiveDetailCategorized
									incentives={
										categorizedIncentives.dealer.regular
									}
									labels={labels}
									setModalStateData={setModalStateData}
									heading={dealerHeading}
									isMobile={isMobile}
								/>
								<IncentiveDetailCategorized
									incentives={categorizedIncentives.oem.regular}
									labels={labels}
									setModalStateData={setModalStateData}
									heading={labels.get(MANUFACTURER)}
									isMobile={isMobile}
								/>
								<IncentiveDetailCategorized
									incentives={
										categorizedIncentives.dealer.conditional
									}
									labels={labels}
									setModalStateData={setModalStateData}
									heading={dealerHeadingConditional}
									headingInfo="info-label"
									isMobile={isMobile}
								/>
								<IncentiveDetailCategorized
									incentives={
										categorizedIncentives.oem.conditional
									}
									labels={labels}
									setModalStateData={setModalStateData}
									heading={`${labels.get(
										MANUFACTURER
									)} (${labels.get(CONDITIONAL)})`}
									headingInfo="info-label"
									isMobile={isMobile}
								/>
							</React.Fragment>
						);
					}}
				/>
			);
		} else {
			return (
				<Common
					render={({ labels }) => {
						const dealerHeading = accountName
							? `${labels.get(ONLY_AT)} ${accountName}`
							: `${labels.get(DEALERSHIP)}`;
						const popoverPlacement = isMobile ? 'top' : 'left';
						const popoverHoverFocus = (
							<Popover id="incentive-detail-popover">
								{labels.get(CONDITIONAL_SPECIAL_DESCRIPTION)}
							</Popover>
						);
						return (
							<React.Fragment>
								<IncentiveDetailCategorized
									incentives={categorizedIncentives.dealer.regular.concat(
										categorizedIncentives.dealer.conditional
									)}
									labels={labels}
									setModalStateData={setModalStateData}
									heading={dealerHeading}
									isMobile={isMobile}
									footnoteConditional
								/>
								<IncentiveDetailCategorized
									incentives={categorizedIncentives.oem.regular.concat(
										categorizedIncentives.oem.conditional
									)}
									labels={labels}
									setModalStateData={setModalStateData}
									heading={labels.get(MANUFACTURER)}
									isMobile={isMobile}
									footnoteConditional
								/>
								<div className="ddc-font-size-small mt-4 text-muted">
									{FOOTNOTE_INDICATOR}{labels.get(CONDITIONAL_SPECIAL)}
									<OverlayTrigger
										trigger={['hover', 'focus']}
										placement={popoverPlacement}
										overlay={popoverHoverFocus}
									>
										<span>
											<i className="ddc-icon ddc-icon-info text-muted d-inline-block pl-2" />
										</span>
									</OverlayTrigger>
								</div>
							</React.Fragment>
						);
					}}
				/>
			);
		}
	}
}

IncentivesCategorized.propTypes = {
	categorizedIncentives: PropTypes.shape({}).isRequired,
	separateConditional: PropTypes.bool.isRequired,
	setModalStateData: PropTypes.func.isRequired,
	isMobile: PropTypes.bool.isRequired,
	accountName: PropTypes.string.isRequired
};

export default IncentivesCategorized;



// WEBPACK FOOTER //
// ./src/components/IncentivesCategorized.jsx